/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:16]
Permissions to update outside the main branch: [false]
*/

import { AxiosInstance } from 'axios';
import { SmsLogFilter, SmsLogTable } from 'models/api/smsLog';
import ResTable from 'models/api/table';

export const getSmsLogs = async (axios: AxiosInstance, params: SmsLogFilter) => {
    const { data } = await axios.get<ResTable<SmsLogTable>>('/SmsLog', {
        params,
    });
    return data;
};

export const getSmsLogExcel = async (
    axios: AxiosInstance,
    params: SmsLogFilter,
    culture?: string
) => {
    const { data } = await axios.get<Blob>('/SmsLog/excel', {
        responseType: 'arraybuffer',
        params: { ...params, culture },
    });
    return data;
};
